import { Component, effect, untracked } from '@angular/core';
import { MatChipListboxChange } from '@angular/material/chips';

import { CipoControlBase } from '@shared/components/fields/cipo-control.base';
import { CipoListConfig } from '@shared/components/fields/common';
import { CipoFormModule } from '@shared/modules/forms.module';
import { CipoOutlineFieldComponent } from '../cipo-outline-field/cipo-outline-field.component';
import { CipoTextViewComponent } from '../cipo-text-view/cipo-text-view.component';

@Component({
  selector: 'cipo-listbox',
  templateUrl: './cipo-listbox.component.html',
  imports: [CipoFormModule, CipoTextViewComponent, CipoOutlineFieldComponent],
})
export class CipoListboxComponent extends CipoControlBase<string | string[], CipoListConfig> {
  selectionChanged(event: MatChipListboxChange) {
    this.control().setValue(event.value);
    this.control().markAsTouched();
    this.control().markAsDirty();
  }
  constructor() {
    super();
    effect(() => {
      const dataSourceInfo = untracked(() => this.fieldData().dataSourceInfo);
      if (!this.deepFieldData.readonly() && dataSourceInfo) {
        untracked(() => this.loadDataSource(dataSourceInfo));
      }
    });
  }
}
